import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import classNames from 'classnames'

import AppBar from '@material-ui/core/AppBar'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'

import Atherton1 from '../imgs/projects/atherton1.jpg'
import Atherton2 from '../imgs/projects/atherton2.jpg'
import Atherton3 from '../imgs/projects/atherton3.jpg'
import Atherton4 from '../imgs/projects/atherton4.jpg'
import Atherton5 from '../imgs/projects/atherton5.jpg'
import Atherton6 from '../imgs/projects/atherton6.jpg'
import Atherton7 from '../imgs/projects/atherton7.jpg'
import Atherton8 from '../imgs/projects/atherton8.jpg'
import Atherton9 from '../imgs/projects/atherton9.jpg'
import Atherton10 from '../imgs/projects/atherton10.jpg'
import Atherton11 from '../imgs/projects/atherton11.jpg'
import Atherton12 from '../imgs/projects/atherton12.jpg'

import Saratoga1 from '../imgs/projects/saratoga1.jpg'
import Saratoga2 from '../imgs/projects/saratoga2.jpg'
import Saratoga3 from '../imgs/projects/saratoga3.jpg'
import Saratoga4 from '../imgs/projects/saratoga4.jpg'
import Saratoga5 from '../imgs/projects/saratoga5.jpg'

import Fremont1 from '../imgs/projects/fremont1.jpg'
import Fremont2 from '../imgs/projects/fremont2.jpg'
import Fremont3 from '../imgs/projects/fremont3.jpg'
import Fremont4 from '../imgs/projects/fremont4.jpg'
import Fremont5 from '../imgs/projects/fremont5.jpg'

import Sunnyvale1 from '../imgs/projects/sunnyvale1.jpg'
import Sunnyvale2 from '../imgs/projects/sunnyvale2.jpg'
import Sunnyvale3 from '../imgs/projects/sunnyvale3.jpg'
import Sunnyvale4 from '../imgs/projects/sunnyvale4.jpg'
import Sunnyvale5 from '../imgs/projects/sunnyvale5.jpg'

import Foster1 from '../imgs/projects/foster1.jpg'
import Foster2 from '../imgs/projects/foster2.jpg'
import Foster3 from '../imgs/projects/foster3.jpg'
import Foster4 from '../imgs/projects/foster4.jpg'
import Foster5 from '../imgs/projects/foster5.jpg'

import Menlopark1 from '../imgs/projects/menlopark1.jpg'
import Menlopark2 from '../imgs/projects/menlopark2.jpg'
import Menlopark3 from '../imgs/projects/menlopark3.jpg'
import Menlopark4 from '../imgs/projects/menlopark4.jpg'
import Menlopark5 from '../imgs/projects/menlopark5.jpg'
import Menlopark6 from '../imgs/projects/menlopark6.jpg'
import Menlopark7 from '../imgs/projects/menlopark7.jpg'
import Menlopark8 from '../imgs/projects/menlopark8.jpg'
import Menlopark9 from '../imgs/projects/menlopark9.jpg'
import Menlopark10 from '../imgs/projects/menlopark10.jpg'
import Menlopark11 from '../imgs/projects/menlopark11.jpg'

import Sanjose1 from '../imgs/projects/sanjose1.jpg'
import Sanjose2 from '../imgs/projects/sanjose2.jpg'
import Sanjose3 from '../imgs/projects/sanjose3.jpg'
import Sanjose4 from '../imgs/projects/sanjose4.jpg'
import Sanjose5 from '../imgs/projects/sanjose5.jpg'
import Sanjose6 from '../imgs/projects/sanjose6.jpg'
import Sanjose7 from '../imgs/projects/sanjose7.jpg'
import Sanjose8 from '../imgs/projects/sanjose8.jpg'
import Sanjose9 from '../imgs/projects/sanjose9.jpg'
import Sanjose10 from '../imgs/projects/sanjose10.jpg'
import Sanjose11 from '../imgs/projects/sanjose11.jpg'
import Sanjose12 from '../imgs/projects/sanjose12.jpg'

import Burlingame1 from '../imgs/projects/burlingame1.jpg'
import Burlingame2 from '../imgs/projects/burlingame2.jpg'
import Burlingame3 from '../imgs/projects/burlingame3.jpg'
import Burlingame4 from '../imgs/projects/burlingame4.jpg'
import Burlingame5 from '../imgs/projects/burlingame5.jpg'
import Burlingame6 from '../imgs/projects/burlingame6.jpg'
import Burlingame7 from '../imgs/projects/burlingame7.jpg'
import Burlingame8 from '../imgs/projects/burlingame8.jpg'
import Burlingame9 from '../imgs/projects/burlingame9.jpg'
import Burlingame10 from '../imgs/projects/burlingame10.jpg'
import Burlingame11 from '../imgs/projects/burlingame11.jpg'
import Burlingame12 from '../imgs/projects/burlingame12.jpg'

import Redwood1 from '../imgs/projects/redwood1.jpg'
import Redwood2 from '../imgs/projects/redwood2.jpg'
import Redwood3 from '../imgs/projects/redwood3.jpg'
import Redwood4 from '../imgs/projects/redwood4.jpg'
import Redwood5 from '../imgs/projects/redwood5.jpg'
import Redwood6 from '../imgs/projects/redwood6.jpg'
import Redwood7 from '../imgs/projects/redwood7.jpg'
import Redwood8 from '../imgs/projects/redwood8.jpg'
import Redwood9 from '../imgs/projects/redwood9.jpg'
import Redwood10 from '../imgs/projects/redwood10.jpg'
import Redwood11 from '../imgs/projects/redwood11.jpg'

import pa1 from '../imgs/projects/pa1.jpg'
import pa2 from '../imgs/projects/pa2.jpg'
import pa3 from '../imgs/projects/pa3.jpg'
import pa4 from '../imgs/projects/pa4.jpg'
import pa5 from '../imgs/projects/pa5.jpg'
import pa6 from '../imgs/projects/pa6.jpg'
import pa7 from '../imgs/projects/pa7.jpg'
import pa8 from '../imgs/projects/pa8.jpg'
import pa9 from '../imgs/projects/pa9.jpg'
import pa10 from '../imgs/projects/pa10.jpg'
import pa11 from '../imgs/projects/pa11.jpg'
import pa12 from '../imgs/projects/pa12.jpg'
import pa13 from '../imgs/projects/pa13.jpg'
import pa14 from '../imgs/projects/pa14.jpg'
import pa15 from '../imgs/projects/pa15.jpg'

import sj1 from '../imgs/projects/sj1.jpg'
import sj2 from '../imgs/projects/sj2.jpg'
import sj3 from '../imgs/projects/sj3.jpg'
import sj4 from '../imgs/projects/sj4.jpg'
import sj5 from '../imgs/projects/sj5.jpg'
import sj6 from '../imgs/projects/sj6.jpg'
import sj7 from '../imgs/projects/sj7.jpg'
import sj8 from '../imgs/projects/sj8.jpg'
import sj9 from '../imgs/projects/sj9.jpg'
import sj10 from '../imgs/projects/sj10.jpg'
import sj11 from '../imgs/projects/sj11.jpg'

const styles = theme => ({
    container: {
        display: 'flex'
    },
    left_bar: {
        width: 200
    },
    content: {
        width: '100%'
    },
    img: {
        width: '100%'
    },
    selected: {
        backgroundColor: theme.palette.grey['400']
    },
    details: {
        paddingLeft: 10
    },
    blue: {
        color: '#393287'
    },
    bar_item: {
        fontSize: 16,
        fontWeight: 'bold',
        color: '#393287'
    }
})

const projectList = [
    {
        name: 'paloalto',
        label: 'Palo Alto SFH New Construction Interior Design'
    },
    // {
    //     name: 'sanjose2',
    //     label: 'San Jose SFH Staging'
    // },
    {
        name: 'redwood',
        label: 'Redwood Shore SFH Interior Design + Staging'
    },
    {
        name: 'atherton',
        label: 'Atherton SFH Interior Design + Staging'
    },
    {
        name: 'burlingame',
        label: 'Burlingame SFH Interior Design + Staging'
    },
    {
        name: 'menlopark',
        label: 'Menlo Park SFH New Construction Interior Design + Staging'
    },
    {
        name: 'sanjose',
        label: 'San Jose SFH New Construction Interior Design'
    },
    {
        name: 'saratoga',
        label: 'Saratoga SFH Staging'
    },
    {
        name: 'fostercity',
        label: 'Foster City SFH Interior Design + Staging'
    },
    {
        name: 'sunnyvale',
        label: 'Sunnyvale SFH Staging'
    },
    {
        name: 'fremont',
        label: 'Fremont SFH Staging'
    },
]
const projectMore = {
    redwood: {
        pics: [
            Redwood1,
            Redwood2,
            Redwood3,
            Redwood9,
            Redwood5,
            Redwood6,
            Redwood7,
            // Redwood8,
            Redwood4,
            Redwood10,
            Redwood11,
        ],
        title: 'Redwood Shore SFH Interior Design + Staging',
        desc: '',
        year: '2019',
        cost: '$5,000'
    },
    atherton: {
        pics: [
            Atherton3,
            Atherton2,
            Atherton1,
            Atherton4,
            // Atherton5,
            Atherton6,
            Atherton7,
            Atherton8,
            Atherton9,
            Atherton10,
            Atherton11,
            Atherton12
        ],
        title: 'Atherton SFH Interior Design + Staging',
        year: '2018',
        cost: '$100,001 ~ $150,000'
    },
    burlingame: {
        pics: [
            Burlingame3,
            Burlingame2,
            Burlingame1,
            Burlingame4,
            Burlingame5,
            Burlingame6,
            Burlingame7,
            Burlingame8,
            Burlingame9,
            Burlingame10,
            Burlingame11,
            Burlingame12
        ],
        title: 'Burlingame SFH Interior Design + Staging',
        desc: '',
        year: '2019',
        cost: '$5,000'
    },
    menlopark: {
        pics: [
            Menlopark1,
            Menlopark10,
            Menlopark3,
            Menlopark4,
            Menlopark5,
            Menlopark6,
            Menlopark7,
            Menlopark2,
            Menlopark8,
            Menlopark9,
            
        ],
        title: 'Menlo Park SFH New Construction Interior Design + Staging',
        desc: 'Beautiful brand new construction 2017. There are 4 bedrooms, 3 baths, including a luxury master suite with walk in closet.',
        year: '2017',
        cost: '$500,001 ~ $750,000'
    },
    sanjose: {
        pics: [
            Sanjose1,
            Sanjose2,
            Sanjose3,
            Sanjose4,
            Sanjose5,
            Sanjose6,
            Sanjose7,
            Sanjose8,
            Sanjose9,
            Sanjose10,
            Sanjose11,
            Sanjose12
        ],
        title: 'San Jose SFH New Construction Interior Design',
        desc: '',
        year: '2020',
        cost: '$3,000'
    },
    saratoga: {
        pics: [
            Saratoga1,
            Saratoga2,
            Saratoga3,
            Saratoga4,
            Saratoga5
        ],
        title: 'Saratoga SFH Staging',
        year: '2018',
        cost: '$2,501 ~ $5,000'
    },
    fostercity: {
        pics: [
            Foster1,
            Foster2,
            Foster3,
            Foster4,
            Foster5
        ],
        title: 'Foster City SFH Interior Design + Staging',
        desc: 'Beautiful wide waterfront location on prestigious Plum Island, with an open and elegant look to modern living and with gated front garden retreats, leads you to a grand foyer. Stunning and spacious living room with vaulted ceilings & fireplace ajacent to an open and chic dining room with gorgeous water views.',
        year: '2016',
        cost: '$50,001 ~ $75,000'
    },
    sunnyvale: {
        pics: [
            Sunnyvale1,
            Sunnyvale2,
            Sunnyvale3,
            Sunnyvale4,
            Sunnyvale5
        ],
        title: 'Sunnyvale SFH Staging',
        desc: '',
        year: '2018',
        cost: '$2,501 ~ $5,000'
    },
    fremont: {
        pics: [
            Fremont1,
            Fremont2,
            Fremont3,
            Fremont4,
            Fremont5
        ],
        title: 'Fremont SFH Staging',
        desc: '',
        year: '2018',
        cost: '$2,501 ~ $5,000'
    },
    paloalto: {
        pics: [
            pa1,
            pa2,
            pa3,
            pa4,
            pa5,
            pa6,
            pa7,
            pa8,
            pa9,
            pa10,
            pa11,
            pa12,
            pa13,
            pa14,
            pa15,
        ],
        title: 'Palo Alto SFH New Construction Interior Design',
        desc: '',
        year: '2020',
        cost: '$2,501 ~ $5,000'
    },
    sanjose2: {
        pics: [
            sj1,
            sj2,
            sj3,
            sj4,
            sj5,
            sj6,
            sj7,
            sj8,
            sj9,
            sj10,
            sj11
        ],
        title: 'San Jose SFH Staging',
        desc: '',
        year: '2020',
        cost: '$2,501 ~ $5,000'
    },
}

class Home extends React.Component{
    state = {
        activeProject : 'paloalto'  //atherton;saratoga;forstcity;sunnyvale;menlopark;fremont
    }

    render(){
        const {classes} = this.props

        return (
            <Grid container>
                <Grid item md={4} sm={12}>
                    <List>
                        {projectList.map(project => (
                            <ListItem button onClick={() => {this.setState({activeProject: project.name})}} className={classNames({[classes.blue]: true, [classes.selected]: this.state.activeProject === project.name})}>
                                <ListItemText disableTypography primary={<Typography variant="body2" className={classes.blue}>{project.label}</Typography>}></ListItemText>
                            </ListItem>
                        ))}
                    </List>
                </Grid>
                <Grid item md={8} sm={12} className={classes.details}>
                    <Typography variant="subtitle1" gutterBottom className={classes.bar_item}>{projectMore[this.state.activeProject].title}</Typography>
                    <Typography variant="body1" gutterBottom className={classes.blue}>{projectMore[this.state.activeProject].desc}</Typography>
                    {/* <Typography variant="subheading" className={classes.blue}>Year:{projectMore[this.state.activeProject].year}</Typography> */}
                    {/* <Typography variant="subheading" className={classes.blue}>Project Cost:{projectMore[this.state.activeProject].cost}</Typography> */}
                    {projectMore[this.state.activeProject].pics.map(pic => (
                        <img src={pic} className={classes.img}/>
                    ))}
                </Grid>
            </Grid>
        )
    }
}

export default withStyles(styles)(Home)